export enum TweenUpdateState
{
  Start,
  Update,
  End
}

export class TweenUpdate
{
  elapsed:number;
  phase:number;
  state:TweenUpdateState;
}

export function tween( duration: number,  callback: ( update: TweenUpdate ) => void ): void
{
  let durationMs = duration * 1000;
  let startTime: number | null = null;
  let ended = false;

  function frame( now: number )
  {
    if ( startTime === null )
    {
      startTime = now;
      callback( { elapsed: 0, phase: 0, state: TweenUpdateState.Start } ); 
      requestAnimationFrame( frame );
      return;
    }

    let elapsedMs = now - startTime;
    let elapsedSeconds = elapsedMs / 1000;

    if ( elapsedMs < durationMs )
    {
      callback( { elapsed: elapsedSeconds, phase: elapsedSeconds/duration, state: TweenUpdateState.Update } );
      requestAnimationFrame( frame );
    }
    else if ( ! ended )
    {
      callback( { elapsed: duration, phase:1, state: TweenUpdateState.End } );
      ended = true;
    }
  }

  requestAnimationFrame( frame );
}